import {store, withSyncEvent} from '@wordpress/interactivity'

store("le-vernay/filter-post", {
	actions: {
		goTo: withSyncEvent(function (e: MouseEvent) {
			const button = e.currentTarget as HTMLButtonElement;
			if (!button) return;
			const link = button.dataset.url;
			if (!link) return;

			window.location.href = link
		})
	}
})
